const escapeMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#x27;",
    "`": "&#x60;"
};
const unescapeMap = {
    "&amp;": "&",
    "&lt;": "<",
    "&gt;": ">",
    "&quot;": '"',
    "&#x27;": "'",
    "&#x60;": "`"
};
function createEscaper(map) {
    function escaper(match) {
        return map[match];
    }
    const source = "(?:" + Object.keys(map).join("|") + ")";
    const testRegexp = RegExp(source);
    const replaceRegexp = RegExp(source, "g");
    return function(string) {
        string = string === null ? "" : "" + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
}
const _escape = createEscaper(escapeMap);
const _unescape = createEscaper(unescapeMap);
export { _escape, _unescape };
